<template>
  <div id="wrapper">
    <component-sidebar :force-mini="false"/>
    <div id="page-wrapper" class="gray-bg">
      <component-header/>
      <component :is="$route.name"/>
    </div>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Sidebar from '../components/Sidebar.vue'
import CommandsList from '../pages/CommandsList'
import CommandCreate from '../pages/CommandCreate'
import CessionsList from '../pages/CessionsList'
import RecapitulatifCession from '../pages/CessionDetails/RecapitulatifCession'
import ExpertiseCreate from '../pages/ExpertiseCreate'

export default {
  components: {
    'component-header': Header,
    'component-sidebar': Sidebar,
    CommandsList,
    CommandCreate,
    CessionsList,
    'recapitulatif-cession': RecapitulatifCession,
    'expertise-create': ExpertiseCreate,
  },

    mounted () {
      $(document).trigger('vue-loaded')
    }
  }
</script>
